import { useDispatch } from "react-redux";
import "./index.scss";
import { push } from "connected-react-router";
import { isEmailValid } from "../../../../services/textService";

const IMPROVE_ITEMS = [
  {
    validator: resume => !resume.firstName,
    icon: (
      <svg width="22" height="22" fill="none" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="8" r="4.25"/><path d="M2.75 18c0-3.5 3.5-5.25 8.25-5.25s8.25 1.75 8.25 5.25"/></svg>
    ),
    label: "Add your first name",
    percent: "+8%"
  },
  {
    validator: resume => !resume.lastName,
    icon: (
      <svg width="22" height="22" fill="none" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="8" r="4.25"/><path d="M2.75 18c0-3.5 3.5-5.25 8.25-5.25s8.25 1.75 8.25 5.25"/></svg>
    ),
    label: "Add your last name",
    percent: "+8%"
  },
  {
    validator: resume => !resume.title,
    icon: (
      <svg width="22" height="22" fill="none" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="5.5" y="7.5" width="11" height="7" rx="2"/><path d="M11 7.5v-2.25"/><circle cx="11" cy="4.5" r="1.25"/></svg>
    ),
    label: "Add the job title",
    percent: "+10%"
  },
  {
    validator: resume => !isEmailValid(resume.email),
    icon: (
      <svg width="22" height="22" fill="none" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3.5" y="5.5" width="15" height="11" rx="2"/><path d="M3.5 8.5h15"/></svg>
    ),
    label: "Add contact email",
    percent: "+12%"
  },
  {
    validator: resume => !resume.summary,
    icon: (
      <svg width="22" height="22" fill="none" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3.5" y="5.5" width="15" height="11" rx="2"/><path d="M3.5 8.5h15"/></svg>
    ),
    label: "Write a summary",
    percent: "+12%"
  },
  {
    validator: resume => !resume.experience?.length,
    icon: (
      <svg width="22" height="22" fill="none" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3.5" y="5.5" width="15" height="11" rx="2"/><path d="M7.5 8.5h6"/><path d="M7.5 11.5h6"/><path d="M7.5 14.5h6"/></svg>
    ),
    label: "Add work experience",
    percent: "+12%"
  },
  {
    icon: (
      <svg width="22" height="22" fill="none" stroke="#222" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 2.75l7.25 3.5v3.5c0 5.25-3.5 9.625-7.25 11.5-3.75-1.875-7.25-6.25-7.25-11.5v-3.5l7.25-3.5z"/><path d="M8.5 10.5l2.5 2.5 2.5-2.5"/></svg>
    ),
    label: "Add education degree",
    percent: "+2%"
  }
];


const ImproveStep = props => {
    const dispatch = useDispatch()
    const onClick = () => {
        dispatch(push(`/resume-builder/${props.resumeId}/personal`))
    }
  return (
    <div className="improve-step-card">
      <h2 className="improve-step-title">Add more details</h2>
      <div className="improve-step-desc">Including these increases your chances of getting an interview.</div>
      <div className="improve-step-list">
        {IMPROVE_ITEMS
        .filter(item => item.validator && item.validator(props.resume))
        .map((item, idx) => (
          <div className="improve-step-list-item" key={idx} onClick={() => onClick()}>
            <span className="improve-step-list-icon">{item.icon}</span>
            <span className="improve-step-list-label">{item.label}</span>
            <span className="improve-step-list-percent">{item.percent}</span>
            <span className="improve-step-list-plus">
              <svg width="22" height="22" fill="none" stroke="#a1a1aa" strokeWidth="2" strokeLinecap="round"><path d="M11 5v12M5 11h12"/></svg>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImproveStep;